/** Keys used to access LocalStorage */
export const LocalStorageKeys = {
  AppliedJobs: 'appliedJobs',
  SavedJobs: 'savedJobs',
};
